import { apiBaseUrl } from "../config";
import { getCartInfo } from "../reducer/userCartSlice";


/**
 * This method is used to add item to the cart
 * @param item
 * @returns {Promise<unknown>}
 */
const addItemToTheCart = async (item, count) => {
    let token = localStorage.getItem("token");
    const cartContext = localStorage.getItem('cartContext')
    const customerId = localStorage.getItem('customerId')
    return new Promise(async (resolve, reject) => {
        try {
            let headers = {
                "Content-Type": "application/json"
            }
            if (token) {
                headers["token"] = token;
            }

            const response = await fetch(
                `${apiBaseUrl}cart/add-item-in-cart`, {
                method: "POST",
                headers: headers,
                body: JSON.stringify({
                    "id": item?.id,
                    "image": item?.image,
                    "price": item?.price,
                    "quantity": count,
                    "storeid": item?.storeid,
                    "title": item?.title,
                    "variant": item?.variant,
                    "cartContext": cartContext,
                    "customerId": customerId,
                    "stock": item?.stock,
                })
            }
            );
            const data = await response.json();
            if (data?.cartContext) {
                localStorage.setItem("cartContext", data.cartContext);
            }
            resolve(data);
        } catch (e) {
            console.error("error while updating the quantity of product")
            reject(e);
        }
    })
}
export default addItemToTheCart;